import React from "react";
import Image from "next/image";

interface AboutSectionTwoDesktopProps {
  title1: string;
  description1: string;
  title2: string;
  description2: string;
  title3: string;
  description3: string;
}

const AboutSectionTwoDesktop = ({
  title1,
  description1,
  title2,
  description2,
  title3,
  description3
}: AboutSectionTwoDesktopProps) => {
  return (
    <div className="container">
      <div className="-mx-4 flex flex-wrap items-center">
        <div className="w-full px-4 lg:w-1/2">
          <div
            className="relative mx-auto mb-12 aspect-[25/24] max-w-[500px] text-center lg:m-0"
            data-wow-delay=".15s"
          >
            <Image
              src="/images/about/about-image-2.png"
              alt="about image"
              fill
              className="drop-shadow-three dark:hidden dark:drop-shadow-none"
            />
            <Image
              src="/images/about/about-image-2-dark.png"
              alt="about image"
              fill
              className="hidden drop-shadow-three dark:block dark:drop-shadow-none"
            />
          </div>
        </div>
        <div className="w-full px-4 lg:w-1/2">
          <div className="max-w-[470px]">
            <div className="mb-9">
              <h3 className="mb-4 text-xl font-bold text-black dark:text-white sm:text-2xl lg:text-xl xl:text-2xl">
                {title1}
              </h3>
              <p className="text-base font-medium leading-relaxed text-body-color sm:text-lg sm:leading-relaxed">
                {description1}
              </p>
            </div>
            <div className="mb-9">
              <h3 className="mb-4 text-xl font-bold text-black dark:text-white sm:text-2xl lg:text-xl xl:text-2xl">
                {title2}
              </h3>
              <p className="text-base font-medium leading-relaxed text-body-color sm:text-lg sm:leading-relaxed">
                {description2}
              </p>
            </div>
            <div className="mb-1">
              <h3 className="mb-4 text-xl font-bold text-black dark:text-white sm:text-2xl lg:text-xl xl:text-2xl">
                {title3}
              </h3>
              <p className="text-base font-medium leading-relaxed text-body-color sm:text-lg sm:leading-relaxed">
                {description3}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutSectionTwoDesktop; 